import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Skill } from '@app/onboarding/onboarding.model';
import { ReviewSkillsService } from '@app/onboarding/services/review-skills.service';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { TagRatingService } from '@app/tags/services/tag-rating.service';
import { TagsApi } from '@app/tags/tag-api.model';
import { InternalTagRatingTypes } from '@app/tags/tags';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-are-you-sure-rating-modal',
  templateUrl: './are-you-sure-rating-modal.component.html',
  styleUrls: ['./are-you-sure-rating-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreYouSureRatingModalComponent {
  @Input() public tag: Skill;
  @Input() public modalTitle: string;
  @Input() public addSkill: boolean;

  public skillitonImage: string = this.getBlobUrl(
    '/content/img/emptystate/empty-notifications.svg'
  );
  public i18n = this.translateService.instant([
    'Onboarding_ProfileSkill',
    'Onboarding_AddedSkill',
  ]);
  constructor(
    private activeModal: NgbActiveModal,
    private webEnvironmentService: WebEnvironmentService,
    private tagRatingService: TagRatingService,
    private translateService: TranslateService,
    private reviewSkillsService: ReviewSkillsService
  ) {}

  /**
   * Submit the level 1 rating
   */
  public submit(): void {
    this.activeModal.dismiss();
    // submit the level rating of 1 since the user is sure
    this.updateRating(null);
  }

  public closeModal(): void {
    this.activeModal.dismiss();
  }

  public onContinue(event: Event): void {
    this.activeModal.dismiss();
    const tagCopy = {
      ...this.tag,
      rating: { level: '1' } as TagsApi.UserTagRating,
    };

    const modal = this.tagRatingService.openRatingModal({
      event,
      title: this.modalTitle,
      tag: tagCopy,
      ratingType: InternalTagRatingTypes.target,
      emptyRating: true,
      instructionsText: this.tag.isFollowing
        ? undefined
        : 'PersonalSkillView_AddSkillIntructions',
      addNewSkill: this.addSkill,
    });

    modal.subscribe((rating: TagsApi.UserTagRating) => {
      this.updateRating(rating);
    });
  }

  public getBlobUrl(url: string): string {
    return this.webEnvironmentService.getBlobUrl(url);
  }

  private updateRating(rating: TagsApi.UserTagRating): void {
    const level = rating ? (rating.level as unknown as number) : 1;
    this.reviewSkillsService.selfRating(this.tag, level);
  }
}
